import { isChinesePublicationLanguage } from '@/lib/abstract-language';
import { isChinese } from '@/lib/text-utils';

type ReferenceTranslationDisplayItem = {
  pub_language?: string | null;
  title?: string | null;
  abstract?: string | null;
  translation?: {
    [key: string]: {
      title?: string | null;
      abstract?: string | null;
    };
  } | null;
};

function normalizeComparableText(value?: string | null) {
  return (value ?? '')
    .toLowerCase()
    .replace(/[\s\u3000,，.。:：;；"'“”‘’《》<>()（）[\]【】\-—_]/g, '')
    .trim();
}

export function getZhReferenceTranslation(item: ReferenceTranslationDisplayItem) {
  return item.translation?.['zh-cn'] ?? item.translation?.zh ?? null;
}

export function shouldShowZhReferenceTranslation(
  item: ReferenceTranslationDisplayItem,
) {
  const zhTranslation = getZhReferenceTranslation(item);
  const translatedTitle = zhTranslation?.title?.trim();
  const translatedAbstract = zhTranslation?.abstract?.trim();
  if (!translatedTitle && !translatedAbstract) {
    return false;
  }

  if (isChinesePublicationLanguage(item.pub_language)) {
    return false;
  }

  if (isChinese(item.title ?? '') || isChinese(item.abstract ?? '')) {
    return false;
  }

  const originalTitle = normalizeComparableText(item.title);
  const originalAbstract = normalizeComparableText(item.abstract);
  const zhTitle = normalizeComparableText(translatedTitle);
  const zhAbstract = normalizeComparableText(translatedAbstract);

  return !(
    Boolean(originalTitle && originalTitle === zhTitle) ||
    Boolean(originalAbstract && originalAbstract === zhAbstract)
  );
}
